export default {
  INTEGRATIONS: `Intégrations`,
  ACTIVE_MODULES: `Modules activés`,
  AVAILABLE_MODULES: `Modules disponibles`,
  AN_OTHER_INTEGRATION_PREVENTS_USE: `Une autre intégration empêche l'utilisation de celle-ci.`,
  WORKDAY: {
    TITLE: `Workday`,
    SUMMARY: `Cette intégration permet de synchroniser les clients, les régions, l'horaire, les projets et les utilisateurs avec Workday.`
  },
  ROSTIMA: { TITLE: `Rostima`, SUMMARY: `Cette intégration permet de synchroniser les requêtes d'absence, l'horaire et les utilisateurs avec Rostima.` },
  CERIDIAN: {
    TITLE: `Ceridian`,
    SUMMARY: `Cette intégration permet de synchroniser l'horaire, les cartes de temps et les utilisateurs avec Ceridian.`,
    SETUP_FTP_INFO: `Veuillez nous contacter afin de configurer le SFTP de cette intégration.`
  },
  FOLKSRH: {
    TITLE: `FolksRH`,
    SUMMARY: `Cette intégration permet de synchroniser les utilisateurs avec FolksRH.`
  },
  GENERAL: { TITLE: `Général`, SUMMARY: `` },
  SCHEDULE: { TITLE: `Horaire`, SUMMARY: `` },
  ATTENDANCE: { TITLE: `Absences`, SUMMARY: `` },
  TIMEOFF: { TITLE: `Congés`, SUMMARY: `` },
  AVAILABILITIES: { TITLE: `Disponibilités`, SUMMARY: `` },
  TIMEATTENDANCE: { TITLE: `Temps & Présence`, SUMMARY: `` },
  EMPLOYEE: { TITLE: `Employés`, SUMMARY: `` },
  CALLSYSTEM: { TITLE: `Système d'appels`, SUMMARY: `` },
  DEPLOYMENT: { TITLE: `Déploiement`, SUMMARY: `` },
  DAILYQUESTIONNAIRE: { TITLE: `Questionnaire journalier`, SUMMARY: `` },
  PUNCHTERMINALQUESTIONNAIRE: { TITLE: `Questionnaire de poinçon`, SUMMARY: `` },
  TRANSITION: { TITLE: `Transition`, SUMMARY: `` },
  form: {
    PROJECTISREQUIRED: {
      LABEL: `Le projet est obligatoire`,
      DESCRIPTION: `Le projet sera requis lors de la création d'un nouveau quart de travail ou d'une nouvelle carte de temps.`
    },
    ENABLESCHEDULENOTES: {
      LABEL: `Activer les notes d'horaire`,
      DESCRIPTION: `Tous les gestionnaires pouvant modifier l'horaire pourront ajouter des notes à l'horaire.`
    },
    ENABLEORGANIZEBYUSERSCHEDULE: {
      LABEL: `Activer l'organisation par utilisateur dans l'horaire`,
      DESCRIPTION: `Active une vue expérimentale où on peut organiser l'horaire pour voir un employé sur chaque ligne.`
    },
    ENABLEPUNCHGEOLOCATION: {
      LABEL: `Ajouter des coordonnées de géolocalisation aux cartes de temps.`,
      DESCRIPTION: `Les utilisateurs d'applications mobiles devront activer les services de localisation dans les paramètres de leur appareil`
    },
    REQUIREEMPLOYEELOCATION: {
      LABEL: `Exiger l'emplacement des employés`,
      DESCRIPTION: `Nécessite que l'employé active les services de localisation pour pointer à l'entrée ou à la sortie.`
    },
    ENABLEAUTOMATICWAGEPREMIUMSBYATTRIBUTE: {
      LABEL: `Activer les primes automatiques par attribut`,
      DESCRIPTION: `Permet de configurer les primes pour qu'elles s'appliquent automatiquement selon les attributs d'un employé.`
    },
    ENABLEAUTOMATICWAGEPREMIUMSBYRANGE: {
      LABEL: `Activer les primes automatiques par date`,
      DESCRIPTION: `Permet de configurer les primes pour qu'elles s'applique automatiquement selon la date et l'heure de la carte de temps.`
    },
    ENABLEEMPLOYEECONTAINERSCHEDULER: {
      LABEL: `Grouper les employés par ligne dans l'horaire`,
      DESCRIPTION: `Forcer les employés à être sur la même ligne dans l'horaire lorsqu'ils sont sur la même position.`
    },
    ENABLESANITYCHECKCONTACTLISTS: {
      LABEL: `Activer la double vérification dans les listes`,
      DESCRIPTION: `Ajoute une verification d'éligibilité dans les listes de contact avant de permettre un employé d'accepter.`
    },
    IGNOREREPORTSTOFORPROJECTS: {
      LABEL: `Ignorer le filtre de se rapporte pour les projets`,
      DESCRIPTION: `Tous les gestionnaires auront accès à tous les projets peut importe s'ils sont gestionnaire de projet ou non.`
    },
    TEAMISREQUIRED: {
      LABEL: `L'équipe est obligatoire`,
      DESCRIPTION: `L'équipe sera requise lors de la création d'un nouveau quart de travail.`
    },
    FTPOPTIONS: {
      LABEL: `Information du ftp où récupérer/déposer les fichiers`,
      DESCRIPTION: ``
    },
    ISTESTCOMPANY: {
      LABEL: `Cette plateforme est un environnement de test`,
      DESCRIPTION: `Certaines fonctionnalités ne seront pas disponibles si ce paramètre est activé.`
    },
    FORCEEMPLOYEEPORTAL: {
      LABEL: `Forcer les employés au nouveau portail`,
      DESCRIPTION: `Si un utilisateur de type employé se connecte sur le vieux portail, il sera redirigé vers le nouveau.`
    },
    FORCENEWPORTAL: {
      LABEL: `Forcer TOUT le monde à se connecter au nouveau portail`,
      DESCRIPTION: `Si un utilisateur se connecte sur le vieux portail, il sera redirigé vers le nouveau portail.`
    },
    DISABLEOLDPORTAL: {
      LABEL: `Empêcher TOUT le monde d'accéder au vieux portail`,
      DESCRIPTION: `Enlevera le bouton pour naviguer au vieux portail à partir du nouveau.`
    },
    ACTIVATEWORKDAYINTEGRATION: {
      LABEL: `Activer l'intégration Workday`,
      DESCRIPTION: ``
    },
    ACTIVATEWORKDAYUSERS: {
      LABEL: `Activer le transfert des utilisateurs`,
      DESCRIPTION: ``
    },
    ACTIVATEWORKDAYSCHEDULE: {
      LABEL: `Activer le transfert de l'horaire`,
      DESCRIPTION: ``
    },
    ACTIVATEWORKDAYTAGS: {
      LABEL: `Activer le transfert des étiquettes`,
      DESCRIPTION: ``
    },
    ACTIVATEWORKDAYPOSITIONS: {
      LABEL: `Activer le transfert des positions`,
      DESCRIPTION: ``
    },
    ACTIVATEWORKDAYPROJECTS: {
      LABEL: `Activer le transfert des projets`,
      DESCRIPTION: ``
    },
    ACTIVATEWORKDAYATTENDANCES: {
      LABEL: `Activer le transfert des absences`,
      DESCRIPTION: ``
    },
    ACTIVATEWORKDAYTIMEOFF: {
      LABEL: `Activer le transfert des congés`,
      DESCRIPTION: ``
    },
    WORKDAYREIMBURSEMENTSURL: {
      LABEL: `URL des remboursements`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    WORKDAYPASSWORD: {
      LABEL: `Mot de passe`,
      PLACEHOLDER: `Entrer le mot de passe`,
      DESCRIPTION: `Mot de passe du compte de l'intégration Workday, ce compte doit avoir toutes les permissions requises pour l'intégration.`
    },
    WORKDAYUSERNAME: {
      LABEL: `Nom d'utilisateur`,
      PLACEHOLDER: `Entrer le nom d'utilisateur`,
      DESCRIPTION: `Nom d'utilisateur du compte de l'intégration Workday, ce compte doit avoir toutes les permissions requises pour l'intégration.`
    },
    WORKDAYERROREMAIL: {
      LABEL: `Courriel d'erreur`,
      PLACEHOLDER: `Entrez une ou plusieurs adresses courriel`,
      DESCRIPTION: `Le courriel auquel les rapports d'erreur seront envoyés, séparez les courriels par des virgules.`
    },
    WORKDAYUSERSURL: {
      LABEL: `WSDL pour les utilisateurs`,
      PLACEHOLDER: `Entrer l'URL du WSDL pour la ressource des utilisateurs.`,
      DESCRIPTION: ``
    },
    WORKDAYUSERONBOARDINGURL: {
      LABEL: `WSDL pour les statut de onboarding des utilisateurs`,
      PLACEHOLDER: `Entrer l'URL du WSDL`,
      DESCRIPTION: ``
    },
    WORKDAYSCHEDULEURL: {
      LABEL: `WSDL pour l'horaire`,
      PLACEHOLDER: `Entrer l'URL du WSDL pour la ressource de l'horaire.`,
      DESCRIPTION: ``
    },
    WORKDAYINTEGRATIONSURL: {
      LABEL: `WSDL pour les intégrations`,
      PLACEHOLDER: `Entrer l'URL du WSDL`,
      DESCRIPTION: ``
    },
    WORKDAYTIMEBLOCKMAPURL: {
      LABEL: `WSDL pour les blocs de temps`,
      PLACEHOLDER: `Entrer l'URL du WSDL`,
      DESCRIPTION: ``
    },
    WORKDAYCLIENTSURL: {
      LABEL: `WSDL pour les clients`,
      PLACEHOLDER: `Entrer l'URL du WSDL pour la ressource des clients.`,
      DESCRIPTION: ``
    },
    WORKDAYATTENDANCEURL: {
      LABEL: `WSDL pour les absences`,
      PLACEHOLDER: `Entrer l'URL du WSDL pour la ressource des absences.`,
      DESCRIPTION: ``
    },
    WORKDAYAVAILABILITIESURL: {
      LABEL: `WSDL pour les disponibilités`,
      PLACEHOLDER: `Entrer l'URL du WSDL pour la ressource des disponibilités.`,
      DESCRIPTION: ``
    },
    WORKDAYTIMEOFFURL: {
      LABEL: `WSDL pour les congés`,
      PLACEHOLDER: `Entrer l'URL du WSDL pour la ressource des congés.`,
      DESCRIPTION: ``
    },
    WORKDAYREGIONSURL: {
      LABEL: `WSDL pour les regions`,
      PLACEHOLDER: `Entrer l'URL du WSDL pour la ressource des regions.`,
      DESCRIPTION: ``
    },
    WORKDAYLOCATIONSURL: {
      LABEL: `WSDL pour les emplacements`,
      PLACEHOLDER: `Entrer l'URL du WSDL pour la ressource des emplacements.`,
      DESCRIPTION: ``
    },
    WORKDAYPOSITIONSURL: {
      LABEL: `WSDL pour les positions`,
      PLACEHOLDER: `Entrer l'URL du WSDL pour la ressource des positions.`,
      DESCRIPTION: ``
    },
    WORKDAYPROJECTSURL: {
      LABEL: `WSDL pour les projets`,
      PLACEHOLDER: `Entrer l'URL du WSDL pour la ressource des projets.`,
      DESCRIPTION: ``
    },
    ACTIVATECERIDIANINTEGRATION: {
      LABEL: `Activer l'intégration Ceridian`,
      DESCRIPTION: ``
    },
    ACTIVATECERIDIANPUNCH: {
      LABEL: `Activer l'ajustement de l'horaire à l'aide des poinçons`,
      DESCRIPTION: ``
    },
    ACTIVATECERIDIANSCHEDULE: {
      LABEL: `Activer le transfert de l'horaire`,
      DESCRIPTION: ``
    },
    ACTIVATECERIDIANUSERS: {
      LABEL: `Activer le transfert des utilisateurs`,
      DESCRIPTION: ``
    },
    ACTIVATEROSTIMAINTEGRATION: {
      LABEL: `Activer l'intégration Rostima`,
      DESCRIPTION: ``
    },
    ROSTIMAUSERNAME: {
      LABEL: `Nom d'utilisateur`,
      PLACEHOLDER: `Entrer le nom d'utilisateur`,
      DESCRIPTION: `Nom d'utilisateur du compte de l'intégration Rostima, ce compte doit avoir toutes les permissions requises pour l'intégration.`
    },
    ROSTIMAPASSWORD: {
      LABEL: `Mot de passe`,
      PLACEHOLDER: `Entrer le mot de passe`,
      DESCRIPTION: `Mot de passe du compte de l'intégration Rostima, ce compte doit avoir toutes les permissions requises pour l'intégration.`
    },
    ROSTIMAURL: {
      LABEL: `Url`,
      PLACEHOLDER: `Entrer l'url`,
      DESCRIPTION: `Addresse du service rostima à utiliser`
    },
    ACTIVATEROSTIMAATTENDANCES: {
      LABEL: `Activer le transfert des absences dans Rostima`,
      DESCRIPTION: ``
    },
    ACTIVATEROSTIMAUSERS: {
      LABEL: `Activer le transfert des utilisateurs dans Merinio`,
      DESCRIPTION: ``
    },
    ACTIVATEROSTIMASCHEDULE: {
      LABEL: `Activer le transfert de l'horaire dans Merinio`,
      DESCRIPTION: ``
    },
    ACTIVATEROSTIMATIMEOFF: {
      LABEL: `Activer le transfert des congés dans Merinio`,
      DESCRIPTION: ``
    },
    ACTIVATEFOLKSRHINTEGRATION: {
      LABEL: `Activer l'intégration FolksRH`,
      DESCRIPTION: ``
    },
    FOLKSRHCLIENTID: {
      LABEL: `Client ID`,
      DESCRIPTION: `Client ID de la plateforme FolkSRH`,
      PLACEHOLDER: `Entrer le client ID`
    },
    FOLKSRHCLIENTSECRET: {
      LABEL: `Client Secret`,
      DESCRIPTION: `Client Secret de la plateforme FolkSRH`,
      PLACEHOLDER: `Entrer le client secret`
    },
    FOLKSRHCLIENTUUID: {
      LABEL: `Client UUID`,
      DESCRIPTION: `Identifiant unique de la plateforme FolkSRH`,
      PLACEHOLDER: `Entrer le uuid`
    },
    FOLKSRHCLIENTURL: {
      LABEL: `Client url`,
      DESCRIPTION: `Url de la plateforme folks`,
      PLACEHOLDER: `Entrer le url`
    },
    INVALID_SCOPE: `Permissions Scope invalides`,
    INVALID_CLIENT: `Client ID ou Client Secret invalide`,
    DISPLAYTAGCUSTOMFIELDS: {
      LABEL: `Montrer les champs personalisés dans les étiquettes.`,
      DESCRIPTION: `Les champs vont permettre de définir les codes à envoyer à l'integration lors de la génération de l'export.`
    },
    ISLARGECOMPANY: {
      LABEL: `Grande entreprise`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Désactive certains calculs plus lourds afin de rendre la plateforme plus performante.`
    },
    DISABLETWILIO: {
      LABEL: `Désactiver twilio`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Désactive toutes les fonctions d'envoi d'sms ou appels. Les listes de rappels seront limitées aux notifications push.`
    },
    DISABLEEMAILS: {
      LABEL: `Désactiver les courriels`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Désactive tous les courriels pour ne pas notifier les employés lorsque le client est en déploiement.`
    },
    GEOLOCALIZATION: {
      LABEL: `Géolocalisation`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Active les fonctionnalités d'ordonnancement selon la distance entre les employés et leurs quarts de travail.`
    },
    SPLITOVERNIGHTSHIFTS: {
      LABEL: `Diviser les quarts de nuit`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Les quarts de nuit compteront seulement dans la journée où les heures sont travaillées. Ceci s'applique à la paie et les calculs d'heures travaillées. Un quart travaillé sur 2 semaines comptera partiellement dans chaque semaine.`
    },
    STANDARDTIMEDATEDISPLAY: {
      LABEL: `Affichage en AM/PM`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Active l'affichage en AM/PM dans les interfaces où les heures sont visibles.`
    },
    STANDARDTIMEDATEDISPLAYWEEKLYREPORT: {
      LABEL: `Rapport hebdomadaire en AM/PM`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Active l'affichage en AM/PM dans l'export du rapport hebdomadaire en PDF.`
    },
    ENABLEPROFILEPICTURE: {
      LABEL: `Photos de profil`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Active les photos de profil des utilisateurs, ils pourront les définir à partir de Gravatar.`
    },
    ENABLEPREFERREDPRONOUNS: {
      LABEL: `Pronoms `,
      PLACEHOLDER: ``,
      DESCRIPTION: `Active la possibilité d'indiquer les pronoms désirés d'un utilisateur.`
    },
    ENABLELEGALNAME: {
      LABEL: `Nom legal`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Active la possibilité d'indiquer le nom legal d'un utilisateur.`
    },
    COMPANYNAMEEN: {
      LABEL: `Nom de l'entreprise en anglais`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Nom utilisé lors des envois textuels aux employés.`
    },
    COMPANYNAMEFR: {
      LABEL: `Nom de l'entreprise en français`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Nom utilisé lors des envois textuels aux employés.`
    },
    DEFAULTTIMEZONE: {
      LABEL: `Fuseau horaire par défaut`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Fuseau horaire utilisé lors de la création de ressources telles que des quarts de travail, des absences et des congés.`
    },
    NUMBEROFALLOWEDPHONES: {
      LABEL: `Nombre maximum de numéros de téléphone`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Limite le nombre de numéros de téléphone que peuvent ajouter les employés à leur profil. Il sera possible de dépasser cette limite à partir du portail gestionnaire.`
    },
    RESTRICTPHONENUMBERTYPES: {
      LABEL: `Types de numéros permis`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Limite les types de numéros que peuvent ajouter les employés à leur profil.`
    },
    SHOWPHONENUMBERHOMECALL: {
      LABEL: `Numéros pour domicile`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet aux utilisateurs d'ajouter des numéros de type Appel à leur profil.`
    },
    SHOWPHONENUMBERMOBILECALL: {
      LABEL: `Numéros pour cellulaire`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet aux utilisateurs d'ajouter des numéros de type Appel puis SMS à leur profil.`
    },
    SHOWPHONENUMBERMOBILESMS: {
      LABEL: `Numéros pour SMS`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet aux utilisateurs d'ajouter des numéros de type SMS à leur profil.`
    },
    SHOWPHONENUMBERDONOTUSE: {
      LABEL: `Numéros non utilisés`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet aux utilisateurs d'ajouter des numéros à ne pas contacter.`
    },
    LIMITNOTIFICATIONTOWORKEMAIL: {
      LABEL: `Limiter aux courriels de travail`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Limite les courriels notifiant d'une requête d'un employé destinée aux gestionnaires aux courriels de type Travail. Les courriels concernant les requêtes du gestionnaire seront envoyés à tous les courriels du profil.`
    },
    DEFAULTDELAYBETWEENCALLS: {
      LABEL: `Délai par défaut entre les appels`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Nombre de minutes que le système devra attendre entre les appels concurrents.`
    },
    COUNTREPLACEDSHIFTHOURS: {
      LABEL: `Compter les heures des quarts remplacés`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Active la comptabilisation des quarts de travail remplacés dans le total des heures travaillées. Si un employé a été remplacé dans une liste de rappel, le quart remplacé comptera quand même dans ses heures travaillées.`
    },
    SAYPOSITIONNAMESINCALLS: {
      LABEL: `Nom des positions dans les appels`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'indiquer les noms des positions lors les appels de remplacements.`
    },
    SENDEMAILCONFIRMATIONCOPYTO: {
      LABEL: `Envoyer une copie de la notification à ces adresses courriels`,
      PLACEHOLDER: ``,
      DESCRIPTION: `S'il y a plusieurs adresses, elles peuvent être séparées par un «;» et seront ajoutées en Copie Conforme (CC).`
    },
    READSHIFTCOMMENT: {
      LABEL: `Lire le commentaire du quart de travail`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Lorsque le système de notification par appel lit les quarts de travail aux employés, les commentaires associés aux quarts vont aussi être lus.`
    },
    SHIFTARRIVALTIMERANGE: {
      LABEL: `Demander l'heure d'arrivée de l'employé`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Si le quart débute dans moins de X minutes, permet de demander à l'employé à quelle heure il arrivera.`
    },
    ENABLECONCURRENTCALLSRATIO: {
      LABEL: `Activer le ratio d'appels simultanés`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet de maintenir un ratio fixe entre le nombre d'appels en attente et le nombre de quarts disponibles.`
    },
    CONCURRENTCALLSRATIO: {
      LABEL: `Ratio d'appels en attente à maintenir`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'utiliser ce ratio pour calculer le nombre d'utilisateurs pouvant être contactés en fonction du nombre de quarts de travail vacants (Doit être supérieur à 0).`
    },
    ACTIVATEBACKUPCALLS: {
      LABEL: `Activer les deuxièmes rappels`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Après un certain délai, si l'employé n'a pas consulté ses offres de quarts, le système le recontactera.`
    },
    BACKUPCALLSDELAY: {
      LABEL: `Délai d'attente avant le deuxième rappel.`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet de définir le délai en minutes avant d'effectuer le deuxième rappel.`
    },
    MAXACTIVECONTACTALLOWED: {
      LABEL: `Nombre maximal de contacts actifs`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet de définir la limite supérieure de contacts actifs d'une liste de contact. La limite effective peut ensuite être gérée dans chacune des listes de contact.`
    },
    MAXCONCURRENTCONTACTALLOWED: {
      LABEL: `Nombre maximal de contacts en attente`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet de définir la limite supérieure de contacts en attente d'une liste de contact. La limite effective peut ensuite être gérée dans chacune des listes de contact.`
    },
    ACTIVATEATTENDANCEPHONE: {
      LABEL: `Activer l'enregistrement des absences au téléphone`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet aux employés de notifier leur absence ou leur retard avec le système téléphonique.`
    },
    ACTIVATEMESSAGEPHONE: {
      LABEL: `Activer l'écoute des offres de quart au téléphone`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet aux employés de consulter leurs offres de quarts de travail avec le système téléphonique.`
    },
    ACTIVATESCHEDULEPHONE: {
      LABEL: `Activer l'écoute de l'horaire au téléphone`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet aux employés de consulter leur horaire avec le système téléphonique.`
    },
    ACTIVATEPUNCHPHONE: {
      LABEL: `Activer le poinçon par téléphone`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet aux employés de poinçonner leur entrée et leur sortie avec le système téléphonique.`
    },
    ACTIVATEPHONECONFIRMATIONS: {
      LABEL: `Activer la notification des quarts de travail au téléphone`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet de notifier les employés par appel plutôt que par courriel.`
    },
    HOURSOFOPERATION: {
      LABEL: `Définir des heures d'opération`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Hors de ces heures, les employés ne seront pas contactés par les listes de contact. Par contre, les employés peuvent toujours intéragir avec le système téléphonique pour consulter leurs offres de quart, accepter/refuser des quarts, soumettre des requêtes d'absence, etc.`
    },
    FORCECANCELLEDSHIFTS: {
      LABEL: `Forcer l'annulation des quarts de travail`,
      PLACEHOLDER: ``,
      DESCRIPTION: `L'application permet plus facilement d'annuler un quart de travail que de le supprimer. Un quart de travail annulé peut encore être consulté et rétabli. Par contre, un quart de travail supprimé est effacé définitivement.`
    },
    ENABLERECCURENCE: {
      LABEL: `Activer la récurrence`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Ajoute un interface permettant de définir des règles de récurrence sur des quarts dans l'horaire.`
    },
    HIDEUNASSIGNABSENCESTIMEOFFSCHEDULE: {
      LABEL: `Cacher l'avertissement de congés et absences`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Cache un bouton qui permet aux gestionnaires de rapidement enlever les employés absents et en congé des quarts.`
    },
    EDITFINALIZEDSHIFTS: {
      LABEL: `Modifier les quarts de travail finalisés`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet aux utilisateurs de modifier un quart de travail finalisé. Sans ce paramètre, il est toutefois possible de modifier les quarts de travail en les dé-finalisant.`
    },
    BREAKSAREREQUIRED: {
      LABEL: `Pauses obligatoires`,
      PLACEHOLDER: ``,
      DESCRIPTION: `L'ajout de pauses sera obligatoire lors de la création ou de la modification d'un quart.`
    },
    SHOWONLYPUBLISHEDSHIFTSINMYSCHEDULE: {
      LABEL: `Montrer seulement les quarts de travail publiés aux employés.`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Les quarts de travail affichés dans « Mon Horaire » devront avoir été publiés afin de pouvoir être vus.`
    },
    AUTOAPPROVEUNPUNCHEDSHIFTS: {
      LABEL: `Approuver automatiquement les quarts non-poinçonnés`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Les cartes de temps créée à partir du modal des quarts non poinçonnés seront automatiquement approuvées. Les quarts dans le modal seront également sélectionnés par défaut.`
    },
    DEFAULTSCHEDULETYPE: {
      LABEL: `Préremplir les nouveaux quarts de travail suivant ce type de quart`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Les heures de début et de fin des nouveaux quarts seront pré-remplies selon les heures de ce type de quart de travail.`
    },
    DEFAULTBEGINNINGOFWEEKDAY: {
      LABEL: `Journée de début de semaine`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet de définir à quel jour de la semaine l'horaire débute.`
    },
    ACTIVATEOVERVIEW: {
      LABEL: `Activer la vue d'ensemble`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet de voir un résumé des heures de début et de fin de quart ainsi que du nombre de quarts par position et par projets.`
    },
    SORTEVENTSBYEMPLOYEENAME: {
      LABEL: `Ordonner les quarts de travail à l'horaire`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'ordonner les quarts de travail qui ont la même position et heure de début / fin.`
    },
    EVENTSORTFIELD: {
      LABEL: `Sélectionner l'information à utiliser afin d'ordonner les quarts de travail`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    MAXCAPACITYLOAD: {
      LABEL: `Durée maximale du chargement simultané du rapport de capacité`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Si vous avez un grand nombre d'utilisateurs et/ou de quarts de travail, il n'est pas recommandé de sélectionner « 2 mois ».`
    },
    DISPLAYPOSITIONSINMAINTEMPLATESVIEW: {
      LABEL: `Afficher les informations de position dans la liste de modèle d'horaire`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Ces informations sont actuellement visibles via le bouton 'Afficher les détails'. Ce paramètre permet d'afficher ces informations sous chaque entrée de modèle dans la liste principale de modèles d'horaire.`
    },
    PROJECTCLIENTFIELD: {
      LABEL: `Permettre d'ajouter des clients aux projets`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    ENABLEPROJECTDEFAULTSHIFTTAGS: {
      LABEL: `Permettre d'ajouter des étiquettes de quart par défaut à des projets`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Les étiquettes par défaut seront chargées sur le quart lorsqu'un projet ayant des étiquettes de quart par défaut est assigné au quart.`
    },
    PROJECTRESTRICTIONS: {
      LABEL: `Attribuer des restrictions aux projets`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'activer les champs restreignant des utilisateurs sur certains projets : Verrouillé, Bloqué et Préféré.`
    },
    PROJECTATTRIBUTES: {
      LABEL: `Ajouter des attributs supplémentaires aux projets`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Les attributs de la position et du projet seront utilisés afin de déterminer l'éligibilité des employés.`
    },
    ENABLEASSOCIATEDPROJECTS: {
      LABEL: `Activer les projets associés`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Lors du calcul du temps travaillé sur un projet, les heures effectuées sur un projet associé vont aussi être comptabilisées.`
    },
    ENABLETEMPLATELISTINPROJECT: {
      LABEL: `Activer la visualisation des modèles d'horaire dans les projets`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'avoir la liste des modèles d'horaire dans la page d'un projet.`
    },
    REQUIRESHIFTVALIDATION: {
      LABEL: `Demander une accusé de réception des notifications d'horaire`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet de demander à l'utilisateur d'accuser réception chacun des quarts de travail et congés contenus dans les courriels de notification d'horaire.`
    },
    SHOWPOSITIONINEMAIL: {
      LABEL: `Positions de travail dans les courriels de notification`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Si ce paramètre n'est pas activé, les employés ne pourront pas savoir à quelle position ils sont affectés.`
    },
    SHOWPROJECTOWNERSINEMAIL: {
      LABEL: `Responsables de projet dans les courriels de notification`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Si ce paramètre n'est pas activé, les employés ne pourront pas savoir qui sont les responsables de leurs projets ni quand ils travaillent.`
    },
    CONFIRSHIFTEMAILBCC: {
      LABEL: `Envoyer les notifications d'horaire à ces adresses courriels`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'envoyer une copie de chacune des notifications par courriel en copie conforme (CC) à ces adresses. (Séparer par un «;» si plusieurs adresses courriels)`
    },
    EMAILREPLYTO: {
      LABEL: `Courriel de réponse`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Adresse courriel de réponse par défaut pour les courriels envoyés par l'application Merinio.`
    },
    REGIONALTAGS: {
      LABEL: `Activer les régions`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'attribuer des régions aux emplacements et aux utilisateurs. Par la suite, il est possible de faire travailler les employés seulement dans leurs régions respectives.`
    },
    ENABLEOCCUPATIONS: {
      LABEL: `Activer les assignations`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'attribuer une assignation primaire et secondaire à tous les employés.`
    },
    ENABLEATTRIBUTES: {
      LABEL: `Activer les attributs`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet de gérer l'éligibilité des employés à un quart de travail selon leurs qualifications, exigences et restrictions.`
    },
    ENABLESHIFTSPECIFICATTRIBUTES: {
      LABEL: `Activer les attributs spécifiques aux quarts`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet aux gestionnaires d'ajouter des attributs spécifiques à un quart de travail, peu importe les requis de la position.`
    },
    PUNCHAUTHENTICATIONEMPLOYEEID: {
      LABEL: `Utiliser le champ « Identifiant d'employé » pour l'authentification au terminal de poinçon`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Oblige les utilisateurs à utiliser leur identifiant d'employé pour se connecter au système.`
    },
    ENABLEUNPUNCHEDSHIFTSNOTIFICATION: {
      LABEL: `Activer les notifications pour les quarts non poinçonnés`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Une notification par email sera envoyée tous les matins contenant la liste des quarts non poinçonnés de la veille.`
    },
    INVERTNUMERICALKEYBOARD: {
      LABEL: `Inverser le clavier de poinçon`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Normalement le clavier ressemble à un clavier de téléphone, s'il est inversé il ressemblera à un clavier d'ordinateur.`
    },
    RECALCULATEPUNCHBREAKS: {
      LABEL: `Recalculer les pauses`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Les pauses seront automatiquement ajoutées selon les règles de pauses aux cartes de temps. Par contre les pauses assignées aux quarts seront ignorées.`
    },
    SORTPUNCHESBYEMPLOYEEFIELD: {
      LABEL: `Ordonner les cartes de temps selon un attribut des employés`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Trier les quarts de travail identiques (position et heure) selon le prénom ou le nom de famille de l'employé.`
    },
    PUNCHSORTFIELD: {
      LABEL: `Sélectionner le champ à utiliser afin d'ordonner les cartes de temps`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    PAYEXPORTCOMPANYID: {
      LABEL: `Identifiant de compagnie à utiliser pour l'export de la paie`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Ce code sera ajouté automatiquement lors de l'exportation de la paie.`
    },
    DEFAULTREGULAREARNINGCODE: {
      LABEL: `Code de gain pour temps régulier par défaut`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Ce code sera ajouté automatiquement lors de l'exportation de la paie pour les heures régulières.`
    },
    ENABLENOPUNCHINOUTNOTIFICATIONS: {
      LABEL: `Activer les notifications Push pour le poinçon d'entrée et de sortie `,
      PLACEHOLDER: ``,
      DESCRIPTION: `Une notification Push sera envoyée aux employés dans les 5 minutes après le début ou la fin de leur quart, s'ils n'ont pas poinçonné leur entrée ou leur sortie.`
    },
    ENABLEPOSITIONTRANSFER: {
      LABEL: `Activer les transferts de position`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet à un employé un transfert de position au cours d'un même quart de travail.`
    },
    ENABLEPROJECTTRANSFER: {
      LABEL: `Activer les transferts de projet`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet à un employé un transfert de projet au cours d'un même quart de travail.`
    },
    ENABLEWAGEPREMIUMS: {
      LABEL: `Activer les code de primes`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Les codes de primes permettent de moduler les exports vers les systèmes de paie.`
    },
    PAYEXPORTTYPE: {
      LABEL: `Type d'export de paie`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    PAYCODEEQUIVALENCES: {
      LABEL: `Équivalences des codes de paie`,
      DESCRIPTION: ``,
      POSITION: `Position`,
      DEPARTMENT: `Département`,
      PROJECT: `Projet`,
      EMPLOYEE: `Employé`,
      NETHRISEMPLOYEURD: {
        TITLE: `Équivalences Nethris/EmployeurD`,
        REGULAREARNINGCODE: {
          LABEL: `Code de gain temps régulier`,
          DESCRIPTION: ``,
          PLACEHOLDER: ``
        },
        HOURLYRATE: {
          LABEL: `Taux horaire`,
          DESCRIPTION: ``,
          PLACEHOLDER: ``
        },
        DIVISION: {
          LABEL: `Division`,
          DESCRIPTION: ``,
          PLACEHOLDER: ``
        },
        SERVICE: {
          LABEL: `Service`,
          DESCRIPTION: ``,
          PLACEHOLDER: ``
        },
        DEPARTMENT: {
          LABEL: `Département`,
          DESCRIPTION: ``,
          PLACEHOLDER: ``
        },
        SUBDEPARTMENT: {
          LABEL: `Sous département`,
          DESCRIPTION: ``,
          PLACEHOLDER: ``
        },
        WORKS1: {
          LABEL: `Code de travail S1`,
          DESCRIPTION: ``,
          PLACEHOLDER: ``
        },
        WORKS2: {
          LABEL: `Code de travail S2`,
          DESCRIPTION: ``,
          PLACEHOLDER: ``
        }
      },
      APOGEE: {
        TITLE: 'Équivalences Apogée',
        FUNCCODE: {
          LABEL: `Func-Code`,
          PLACEHOLDER: `Entrez un code`,
          DESCRIPTION: ``
        },
        FUNCTLEVEL: {
          LABEL: `Funct-Level`,
          PLACEHOLDER: `Entrez un code`,
          DESCRIPTION: ``
        }
      }
    },
    DEFAULTPUNCHRULE: {
      LABEL: `Activer une règle de cartes de temps par défaut`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Cette règle de cartes de temps sera utilisée par défaut pour les départements et positions.`,
      PUNCHRULEID: {
        LABEL: `Choisir une règle de cartes de temps`,
        PLACEHOLDER: ``,
        DESCRIPTION: ``
      }
    },
    PREVENTEMPLOYEEEARLYOUTREQUESTS: {
      LABEL: `Empêcher les employés de soumettre des départs hâtifs.`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Il ne sera possible de créer des départs hâtifs qu'à partir du portail gestionnaire.`
    },
    PREVENTEMPLOYEELATEREQUESTS: {
      LABEL: `Empêcher les employés de soumettre des retards.`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Il ne sera possible de créer des retards qu'à partir du portail gestionnaire.`
    },
    PREVENTEMPLOYEEABSENCEREQUESTS: {
      LABEL: `Empêcher les employés de soumettre des absences.`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Il ne sera possible de créer des absences qu'à partir du portail gestionnaire.`
    },
    CREATEATTENDANCEWITHOUTSHIFT: {
      LABEL: `Créer des requêtes d'absence sans quart de travail`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Les utilisateurs peuvent soumettre une requête d'absence pour le jour même et le lendemain, même s'ils n'ont pas de quart de travail. Ils peuvent également faire une demande jusqu’au nombre de jours devant précéder la création d’une requête d’absence demandée via l’application.`
    },
    CREATEATTENDANCEONLYONCONFIRMEDSHIFT: {
      LABEL: `Permettre de créer des requêtes d'absence seulement sur des quarts confirmés`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Les utilisateurs peuvent soumettre des requêtes d'absence seulement pour les quarts de travail qui ont été confirmés. (S’ils en ont le droit, ils seront capables d’en soumettre une pour la journée même ou le lendemain. Ils peuvent également faire une demande jusqu’au nombre de jours devant précéder la création d’une requête d’absence demandée via l’application)`
    },
    ATTENDANCEOVERPHONENOSHIFTMATCHING: {
      LABEL: `Empêcher le système d'appel d'essayer de faire correspondre une demande d'absence avec un quart de travail`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    NUMBEROFDAYSINADVANCEOFATTENDANCEREQUEST: {
      LABEL: `Nombre de jours devant précéder la création d'une requête de d'absence`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Ce paramètre s’applique au module d’absences de l’application web ainsi qu’à celui du système d’appels automatisés. Le module de vacances devra être utilisé pour les requêtes hors de cette période. (D’un maximum de 9 jours.)`
    },
    DONTOFFERATTENDANCEQUICKCREATE: {
      LABEL: `Empêcher les absences rapides lors des notifications`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Le message proposant aux employés de créer une absence rapidement à partir de l'appel de notification ne sera pas joué.`
    },
    DONTSHOWPHONENUMBERATTENDANCE: {
      LABEL: `Cacher le numéro de téléphone d'où proviennent les requêtes d'absence`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Les utilisateurs n'ayant pas la permission de voir les numéros de téléphone des autres utilisateurs ne pourront pas voir les numéros de téléphone utilisés pour les requêtes. Activer ce paramètre enlèvera également le numéro de téléphone des courriels de notifications d'absences.`
    },
    REDIRECTTOPHONEONLEAVE: {
      LABEL: `Rediriger les utilisateurs vers un numéro de téléphone lorsqu'ils appellent le système pour une absence ou d'un retard`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet de spécifier un numéro de téléphone pour la compagnie entière ou par département dans la page de gestion des départements (le système utilisera le numéro de département en priorité).`
    },
    REDIRECTTOPHONEONLEAVEPHONENUMBER: {
      LABEL: `Numéro de téléphone de redirection`,
      PLACEHOLDER: ``,
      DESCRIPTION: `L'employé sera redirigé vers ce numéro de téléphone après qu'une requête d'absence ait été créée au téléphone.`
    },
    REDIRECTTOPHONEONLEAVEPHONENUMBEREXTENSION: {
      LABEL: `Extension`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    DEFAULTLEAVESTATUS: {
      LABEL: `Statut par défaut d'une requête de d'absence`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Si une requête d'absence ne possède pas de statut particulier à sa création, celui-ci sera utilisé. Si ce paramètre n'est pas défini, le statut « En cours » sera utilisé.`
    },
    ATTENDANCEDESCRIPTIONENABLED: {
      LABEL: `Ajouter une bulle informative dans la page de modification de « Mes absence »`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Le texte entrée ci-dessous sera affiché dans un encadré bleu.`
    },
    ATTENDANCEDESCRIPTIONEN: {
      LABEL: `Entrer l'information à afficher aux utilisateurs anglophones`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    ATTENDANCEDESCRIPTIONFR: {
      LABEL: `Entrer l'information à afficher aux utilisateurs francophones`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    ABSENCEBANKENABLED: {
      LABEL: `Activer les banques d'absences`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Lorsque cette option est activée, la liste des absences de l'utilisateur pour la période en cours lui sera présentée lors de la création d'une requête d'absence. Une fois que l'utilisateur aura dépassé le nombre d'absences spécifié, il sera averti lors de la création d'une requête d'absence via l'interface et également par téléphone. Remarque : le nombre de demandes et la durée de la période doivent être spécifiés.`
    },
    ABSENCEBANKMAXREQUESTS: {
      LABEL: `Nombre d'absences par période`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Une fois que le nombre de requête d'absences effectuées dans la période en cours dépasse ce nombre, un avertissement sera affiché à l'utilisateur.`
    },
    ABSENCEBANKPERIOD: {
      LABEL: `Durée de la période`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Le nombre de jours dans une période donnée. La quantité d'absences de l'utilisateur sera calculée à rebours à partir d’aujourd’hui, inclusivement.`
    },
    HOURSPERPERIODRRW: {
      LABEL: `Droit de refuser de travailler un certain nombre d'heures par période`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    MAXHOURSPERPERIODRRW: {
      LABEL: `Nombre maximal d'heures qu'un employé peut travailler par période`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    MAXHOURSPERIODRRW: {
      LABEL: `Longueur de la période en heures`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    MANDATORYCREATEREQUESTCOMMENT: {
      LABEL: `Obliger les employés à entrer un commentaire lors de la création d'une requête`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Ce paramètre s'applique aux 3 modules de requêtes, soit Absences, Congés et Disponibilités.`
    },
    ACTIVATETEMPORARYAVAILABILITIES: {
      LABEL: `Activer les disponibilités temporaires`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet aux employés de soumettre des disponibilités temporaires (semblables aux disponibilités régulières mais avec une date de fin).`
    },
    APPROVEAVAILABILITIESAUTOMATICALLY: {
      LABEL: `Approuver les disponibilités automatiquement`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Les disponibilités créées par un employé seront automatiquement approuvées sans intervention de la part d'un gestionnaire.`
    },
    ENABLEPREFERREDRANGES: {
      LABEL: `Activer les les plages de préférence`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet aux employés d'indiquer les plages horaires qui leur conviennent le mieux.`
    },
    ENABLEATTRIBUTESEXPIRATION: {
      LABEL: `Activer l'expiration des attributs`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'ajouter une date d'expiration aux attributs, et de paramétrer des rappels de renouvellement à envoyer aux employés.`
    },
    ENABLEELIGIBILITYFIX: {
      LABEL: `Activer la résolution rapide des problèmes d'éligibilité `,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet de régler les problèmes d'éligibilité directement lors de la création d'un quart de travail.`
    },
    enableAutomaticOvertime: {
      LABEL: `Activer le calcul du temps supplémentaire`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet aux administrateurs de configurer des seuils de temps supplémentaire par jour et par semaine dans les cartes de temps.`
    },
    ENABLEINAPPCHAT: {
      LABEL: `Activer la messagerie`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet aux employés de communiquer entre eux directement dans l'application.`
    },
    ENABLENEWCHAT: {
      LABEL: `Activer le nouveau chat`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Utiliser le nouveau chat`
    },
    AVAILABILITYDESCRIPTIONENABLED: {
      LABEL: `Ajouter une bulle informative dans la page de modification de « Mes disponibilités »`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Le texte entré ci-dessous sera affiché dans un encadré bleu.`
    },
    AVAILABILITYDESCRIPTIONEN: {
      LABEL: `Entrer l'information à afficher aux utilisateurs anglophones`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    AVAILABILITYDESCRIPTIONFR: {
      LABEL: `Entrer l'information à afficher aux utilisateurs francophones`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    ENABLEAVAILABILITYSUBMISSIONCUTOFF: {
      LABEL: `Activer la date limite pour les disponibilités`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'empêcher les employés de soumettre des disponibilités pour une semaine à venir après une heure spécifique d'un jour dans la semaine. Nous recommandons d'expliquer le fonctionnement de la date limite dans le champ de description pour les disponibilités.`
    },
    AVAILABILITYSUBMISSIONCUTOFFDAYOFWEEK: {
      LABEL: `Jour de la semaine`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Jour à utiliser pour la date limite.`
    },
    AVAILABILITYSUBMISSIONCUTOFFTIME: {
      LABEL: `Heure de la journée`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Heure à utiliser pour la date limite, dans le fuseau horaire de l'employé.`
    },
    AVAILABILITYSUBMISSIONCUTTOFFNUMBEROFWEEKSAHEAD: {
      LABEL: `Nombre de semaines d'avance`,
      PLACEHOLDER: `Entrez un chiffre`,
      DESCRIPTION: `Utilisez 1 pour la semaine prochaine et plus pour les autres semaines, entrer zéro (0) ne fera rien.`
    },
    AVAILABILITYSUBMISSIONCUTTOFFREMINDER: {
      LABEL: `Activer le rappel de soumission des disponibilités`,
      DESCRIPTION: `Un rappel par notification push sera envoyé 4 heures avant la date limite à tous les employés qui ont activé leur notifications. `
    },
    TIMEOFFDESCRIPTIONENABLED: {
      LABEL: `Ajouter une bulle informative dans la page de modification de « Mes congés »`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Le texte entré ci-dessous sera affiché dans un encadré bleu.`
    },
    TIMEOFFDESCRIPTIONEN: {
      LABEL: `Entrer l'information à afficher aux utilisateurs anglophones`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    TIMEOFFDESCRIPTIONFR: {
      LABEL: `Entrer l'information à afficher aux utilisateurs francophones`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    OVERLAPPINGTIMEOFFWARNING: {
      LABEL: `Afficher seulement un avertissement pour les congés se chevauchant`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Affichera uniquement un avertissement lorsque l'utilisateur crée un nouveau congé qui chevauche un congé existant. L'action de soumettre le formulaire sera permise.`
    },
    SHOWVACATIONBANKEDMINUTESFIELD: {
      LABEL: `Permettre de définir une banque de vacances par utilisateur pour les choix de vacances`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Un champ « Banque de vacances » dans la liste des utilisateurs permet d'indiquer leur nombre de jours de congés (en minutes) disponibles.`
    },
    VALIDATEINFORMATIONSENDEMAILRESOURCE: {
      LABEL: `Courriel à utiliser quand les employés demandent des changements`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Séparez les adresses courriel par des « ; ».`
    },
    EMAILFORFEEDBACKNOTIFICATIONS: {
      LABEL: `Courriel à utiliser pour les commentaires des employés.`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Lorsqu'un utilisateur clique sur le bouton « Envoyer un commentaire » en bas de l'application, les commentaires destinés à l'employeur seront réacheminés vers cette adresse courriel.`
    },
    EMAILFORATTRIBUTEEXPIRATIONREMINDERS: {
      LABEL: `Courriel à utiliser pour les rappels d'expiration des attributs.`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Si l'option est choisie pour le rappel, il sera envoyé non seulement à l'employé mais aussi à cette adresse courriel. Séparez les adresses courriel par des « ; ».`
    },
    EMAILFORUNPUNCHEDSHIFTSNOTIFICATIONS: {
      LABEL: `Addresse courriel à laquelle envoyer les notifications.`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    ACTIVATEEXPIREDHIRINGDATANOTIFICATIONEMAIL: {
      LABEL: `Activer les notifications pour les données d'embauche arrivant à expiration.`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Une notification sera envoyée tous les soirs aux utilisateurs dont les données d'embauche sont sur le point d'expirer.`
    },
    EXPIREDHIRINGDATANOTIFICATIONEMAIL: {
      LABEL: `Courriel pour les données d'embauche expirées`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'envoyer un courriel à cette personne lorsque ses données d'embauche arrivent à expiration. Séparez les adresses courriel par des « ; ».`
    },
    EXPIREDHIRINGDATAEMAILDAYSTOCHECK: {
      LABEL: `Prévenir l'employé un certain nombre de jours avant l'expiration`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet de déterminer combien de jours d'avance il est nécessaire de contacter l'employé pour le prévenir que ses données d'embauche arrivent à expiration (7 jours par défaut).`
    },
    FALLBACKHIRINGDATA: {
      LABEL: `Permet de définir des données d'embauche de secours`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Si une donnée d'embauche a un repli, les données d'embauche seront supprimées de l'utilisateur à son expiration et seront remplacées par son repli.`
    },
    TRANSFEREVENTSINS3: {
      LABEL: `Transférer les quarts de travail dans S3`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'obtenir tous les événements pour un mois ou une année spécifique à partir de l'API.`
    },
    WEBAPPAUTHTENTATIVE: {
      LABEL: `Nombre de tentatives d'accès à l'application web`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Nombre maximal de tentatives autorisé pour se connecter à l'application web (Inscrire 0 pour infini).`
    },
    PHONEPINENABLE: {
      LABEL: `Authentification par mot de passe lors des appels`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Les utilisateurs qui seront appelés par le système ou qui appelleront le système devront s'authentifier à l'aide d'un mot de passe numérique (entre 4 et 8 caractères) en plus de leur numéro d'employé.`
    },
    PHONETENTATIVEENDMESSAGEFR: {
      LABEL: `Message en français à dire à l'utilisateur`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'ajouter un message pour indiquer aux utilisateurs comment retrouver l'accès au système téléphonique. Message français : Vous avez dépassé votre nombre de tentatives autorisées [Nombre de tentatives] Au revoir.`
    },
    PHONETENTATIVEENDMESSAGEEN: {
      LABEL: `Message en anglais à dire à l'utilisateur`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'ajouter un message pour indiquer aux utilisateurs comment retrouver l'accès au système téléphonique. English message: You have reached the attempt limit [Number of attempts] Goodbye.`
    },
    PHONEAUTHTENTATIVE: {
      LABEL: `Nombre de tentatives d'accès à l'interface téléphonique`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Nombre maximal de tentatives autorisé pour se connecter à l'interface téléphonique (inscrire 0 pour infini).`
    },
    CUSTOMPASSWORDVALIDATION: {
      LABEL: `Utiliser la validation de mot de passe personnalisée`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Les exigences par défaut de Merinio exigent un mot de passe de 8 caractères au minimum et 64 au maximum, et permettent l’utilisation de n'importe quel caractère. Lorsqu'elle est activée, la chaîne de regex saisie ci-dessous sera utilisée pour valider toutes les demandes de création ou de modification de mot de passe.`
    },
    CUSTOMPASSWORDVALIDATIONREGEX: {
      LABEL: `Chaîne de regex personnalisée utilisée dans la validation`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Exemple: Entrer « [a-zA-Z0-9] {8,20} » dans ce champ ne validera que les candidats ayant un mots de passe alphanumériques entre 8 et 20 caractères. Les barres obliques inverses (\\) seront automatiquement échappées : pour «\\D» entrez simplement «\\D».`
    },
    CUSTOMPASSWORDVALIDATIONMSG: {
      LABEL: `Message de validation du mot de passe personnalisé`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Entrez un bref message à afficher lorsque la valeur entrée ne correspond pas aux exigences définies par la chaîne regex de validation personnalisée.`
    },
    TWILIONUMBER: {
      LABEL: `Numéro de téléphone (twilio)`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    TWILIOSID: {
      LABEL: `SID (twilio)`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    TWILIOAUTHTOKEN: {
      LABEL: `Token (twilio)`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    TWILIOURL: {
      LABEL: `URL (twilio)`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    TWILIONAMEFR: {
      LABEL: `Nom phonétique de l'entreprise en français`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Nom utilisé lors des appels aux employés.`
    },
    TWILIONAMEEN: {
      LABEL: `Nom phonétique de l'entreprise en anglais`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Nom utilisé lors des appels aux employés.`
    },
    TWILIONUMBERPRETTY: {
      LABEL: `Numéro de téléphone prononçable (twilio)`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    TWILIOMAINLANGUAGE: {
      LABEL: `Langue par défaut du système d'appel`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    BELONGSTOGROUP: {
      LABEL: `Appartient au groupe`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Ajoutez le nom du groupe auquel la compagnie appartient, ceci permet de partager un numéro entre plusieurs entreprises`
    },
    BELONGSTOGROUPORDER: {
      LABEL: `Ordre dans le groupe`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Une plus petite valeur mettra la compagnie avant les autres dans le groupe`
    },
    CLIENTSTATUS: {
      LABEL: `Statut du client`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    PLANTYPE: {
      LABEL: `Type de plan`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    PERUSERPRICE: {
      LABEL: `Prix par utilisateur`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    PERCONTACTPRICE: {
      LABEL: `Prix par contact`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    MAXUSER: {
      LABEL: `Nombre d'utilisateurs maximal`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    BILLEDUSER: {
      LABEL: `Nombre d'utilisateurs facturables`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    MAXCONTACT: {
      LABEL: `Nombre maximal de contacts`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    BILLEDCONTACT: {
      LABEL: `Nombre de contacts facturables`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    AUTOMATICSCHEDULING: {
      LABEL: `Comblement de quart automatique`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'activer l'option de comblement automatique des quarts de travail dans l'outil d'horaire principal.`
    },
    ENABLEEMPLOYEEID: {
      LABEL: `Identifiant d'employé`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'afficher le champ "identifiant d'employé" dans le formulaire de création/édition des utilisateurs.`
    },
    ENABLESTATUS: {
      LABEL: `Statut`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'afficher le champ "statut" dans le formulaire de création/édition des utilisateurs.`
    },
    ENABLESENIORITYDATE: {
      LABEL: `Date d'ancienneté`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'afficher le champ "date d'ancienneté" dans le formulaire de création/édition des utilisateurs.`
    },
    ENABLEPRIORITYNUMBER: {
      LABEL: `Numéro de priorité`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'afficher le champ "numéro de priorité" dans le formulaire de création/édition des utilisateurs.`
    },
    ENABLESTARTDATE: {
      LABEL: `Date d'entrée en fonction`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'afficher le champ "date d'entrée en fonction" dans le formulaire de création/édition des utilisateurs.`
    },
    ENABLETERMINATIONDATE: {
      LABEL: `Date de cessation de travail`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'afficher le champ "date de cessation de travail" dans le formulaire de création/édition des utilisateurs.`
    },
    ENABLEPROJECTS: {
      LABEL: `Projets`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'afficher le champ "projets" dans le formulaire de création/édition des utilisateurs.`
    },
    ENABLETEAMS: {
      LABEL: `Équipes`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'afficher le champ "équipes" dans le formulaire de création/édition des utilisateurs.`
    },
    ENABLEDEPARTMENTS: {
      LABEL: `Departements`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'afficher le champ "départements" dans le formulaire de création/édition des utilisateurs.`
    },
    ENABLESPECIFICRESTRICTIONS: {
      LABEL: `Restrictions spécifiques`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'afficher le champ "restrictions spécifiques" dans le formulaire de création/édition des utilisateurs.`
    },
    ENABLEPAY: {
      LABEL: `Paie`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'afficher le champ "paie" dans le formulaire de création/édition des utilisateurs.`
    },
    ENABLEEMERGENCYCONTACT: {
      LABEL: `Contacts d'urgence`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'afficher le champ "contacts d'urgence" dans le formulaire de création/édition des utilisateurs.`
    },
    ENABLECLIENTSENIORITY: {
      LABEL: `Ancienneté par client`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'afficher le champ "ancienneté par client" dans le formulaire de création/édition des utilisateurs.`
    },
    ENABLEPOSITIONSENIORITY: {
      LABEL: `Ancienneté par position`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'afficher le champ "ancienneté par position" dans le formulaire de création/édition des utilisateurs.`
    },
    USE_THIS_INPUT_TO_VALIDATE_REGEX: {
      LABEL: `Testez l'expression régulière en entrant un mot de passe`,
      DESCRIPTION: ``
    },
    COMPANYDEFAULTLANGUAGE: {
      LABEL: `Langue par défaut`,
      DESCRIPTION: `Détermine la langue par défaut lors d'un appel téléphonique au système ou lors de la création d'un utilisateur.`
    },
    ENABLEPUNCHQUESTIONNAIRE: {
      LABEL: `Activer le questionnaire de poinçon`,
      DESCRIPTION: `Un questionnaire sera présenté à chaque employé qui poinçonnera en passant par le terminal de poinçon.`
    },
    ENABLEPUNCHCOMMENT: {
      LABEL: `Activer les commentaires en cas d'entrée ou de sortie en avance ou en retard`,
      DESCRIPTION: `Les employés qui poinçonneront leur entrée ou leur sortie en retard ou en avance auront la possibilité d'écrire une note justificative à leur gestionnaire.`
    },
    PUNCHQUESTIONNAIREEMAILTOONERROR: {
      LABEL: `Courriel pour les avertissements`,
      PLACEHOLDER: `Entrez des addresses courriels`,
      DESCRIPTION: `Permet d'envoyer des courriels lorsqu'un employé reçoit un avertissement ou ajoute une explication. Séparez les adresses courriel par des « ; ».`
    },
    PUNCHQUESTIONNAIRECUSTOMERROR: {
      LABEL: `Message d'erreur à afficher`,
      PLACEHOLDER: `Entrez un message`,
      DESCRIPTION: `Sera affiché à un employé qui aura répondu « Oui » à au moins une des questions. Le message devrait contenir des instructions sur la marche à suivre.`
    },
    PUNCHQUESTIONNAIRECUSTOMEXPLANATION: {
      LABEL: `Explication à afficher`,
      PLACEHOLDER: `Entrez un message`,
      DESCRIPTION: `Ce message devra expliquer pourquoi l'employé doit remplir un questionnaire.`
    },
    PUNCHQUESTIONNAIRETIMEBETWEENFILLS: {
      LABEL: `Temps entre les questionnaires`,
      PLACEHOLDER: `Entrez un nombre d'heures`,
      DESCRIPTION: `Définit l'intervalle auquel l'employé doit remplir le questionnaire de poinçon.`
    },
    PUNCHQUESTIONNAIREQUESTIONS: {
      LABEL: `Questions du questionnaire de poinçon`,
      DESCRIPTION: `Questions à poser lors du poinçonnage quand le questionnaire est actif.`,
      TEXT: {
        LABEL: `Question`,
        PLACEHOLDER: `Entrez une question`,
        DESCRIPTION: `La question doit pouvoir être répondue par oui ou non, puisque l'employé devra cocher ce qui s'applique à sa situation.`
      },
      PREVENTSUSERFROMPUNCHING: {
        LABEL: `Empêcher l'utilisateur de poinçonner`,
        DESCRIPTION: `Si l'utilisateur réponds « Oui » à cette question, il ne pourra pas continuer à poinçonner.`
      },
      ADD_QUESTION: `Ajouter une question`
    },
    ENABLEDAILYQUESTIONNAIRE: {
      LABEL: `Activer le questionnaire journalier`,
      DESCRIPTION: `Un questionnaire sera présenté à chaque employé qui se connectera à l'application.`
    },
    SENDDAILYQUESTIONNAIREREMINDERS: {
      LABEL: `Envoyer des rappels`,
      DESCRIPTION: `Un rappel sera envoyé une fois par jour à tous les employés qui n'auront pas rempli le formulaire dans le délai prescrit.`
    },
    ENABLEDAILYQUESTIONNAIREBYPHONE: {
      LABEL: `Permettre les réponses par téléphone`,
      DESCRIPTION: `Les employés pourront appeler le numéro de la compagnie fournit par Merinio afin de remplir le questionnaire.`
    },
    DAILYQUESTIONNAIREEMAILTOONERROR: {
      LABEL: `Courriel pour les avertissements`,
      PLACEHOLDER: `Entrez des addresses courriels`,
      DESCRIPTION: `Permet d'envoyer des courriels lorsqu'un employé reçoit un avertissement ou ajoute une explication. Séparez les adresses courriel par des « ; ».`
    },
    DAILYQUESTIONNAIREHIRINGDATA: {
      LABEL: `Données d'embauche`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Seules les employés possédant les données d'embauche sélectionnées auront à remplir le questionnaire journalier. Laisser vide pour permettre à tous les employés de le remplir.`
    },
    DAILYQUESTIONNAIRECUSTOMERROR: {
      LABEL: `Message d'erreur à afficher`,
      PLACEHOLDER: `Entrez un message`,
      DESCRIPTION: `Sera affiché à un employé qui aura répondu « Oui » à au moins une des questions. Devrait contenir des instructions sur la marche à suivre.`
    },
    DAILYQUESTIONNAIRECUSTOMEXPLANATION: {
      LABEL: `Explication à afficher`,
      PLACEHOLDER: `Entrez un message`,
      DESCRIPTION: `Ce message devra expliquer pourquoi l'employé doit remplir un questionnaire.`
    },
    DAILYQUESTIONNAIRETIMEBETWEENFILLS: {
      LABEL: `Temps entre les questionnaires`,
      PLACEHOLDER: `Entrez un nombre d'heures`,
      DESCRIPTION: `Définit l'intervalle auquel l'employé doit remplir le questionnaire journalier.`
    },
    DAILYQUESTIONNAIREQUESTIONS: {
      LABEL: `Questions du questionnaire journalier`,
      DESCRIPTION: `Questions à poser lors de la connexion à Merinio quand le questionnaire est actif.`,
      TEXT: {
        LABEL: `Question`,
        PLACEHOLDER: `Entrez une question`,
        DESCRIPTION: `La question doit pouvoir être répondue par oui ou non, puisque l'employé devra cocher ce qui s'applique à sa situation.`
      },
      TRIGGERSERRORMESSAGE: {
        LABEL: `Activer le message d'erreur`,
        DESCRIPTION: `Si l'utilisateur réponds « Oui » à cette question, il recevra un message d'erreur tel que défini plus haut.`
      },
      ADD_QUESTION: `Ajouter une question`
    },
    ENABLEATTENDANCEREPORT: { LABEL: `Activer le rapport d'absences`, DESCRIPTION: `` },
    ENABLEATTRIBUTESREPORT: { LABEL: `Activer le rapport d'attributs`, DESCRIPTION: `` },
    ENABLEEXPIRINGATTRIBUTESREPORT: { LABEL: `Activer le rapport d'attributs arrivant à expiration`, DESCRIPTION: `` },
    ENABLEAVAILABILITYREPORT: { LABEL: `Activer le rapport de disponibilités`, DESCRIPTION: `` },
    ENABLECONTACTLISTACCEPTEDREFUSEDREPORT: { LABEL: `Activer le rapport d'acceptation et refus dans les listes de contact`, DESCRIPTION: `` },
    ENABLEDAILYSUMMARYREPORT: { LABEL: `Activer le rapport journalier sommaire`, DESCRIPTION: `` },
    ENABLEPAYREPORT: { LABEL: `Activer le rapport de paie`, DESCRIPTION: `` },
    ENABLETIMEOFFANDATTENDANCEPAYREPORT: {
      LABEL: `Activer le rapport de paie pour les congés et absences`,
      DESCRIPTION: ``
    },
    ENABLEPROJECTOWNERWORKLOADREPORT: { LABEL: `Activer le rapport de charge de travail des responsables de projet`, DESCRIPTION: `` },
    ENABLEPROJECTSCHEDULINGREPORT: { LABEL: `Activer le rapport de planification des projets à l'horaire`, DESCRIPTION: `` },
    ENABLEPROJECTUSERSTATUSREPORT: { LABEL: `Activer le rapport de statut d'utilisateurs assignés à un projet `, DESCRIPTION: `` },
    ENABLEQUESTIONNAIRERESPONSEREPORT: { LABEL: `Activer le rapport des réponses aux questionnaires`, DESCRIPTION: `` },
    ENABLESCHEDULEANALYSISREPORT: { LABEL: `Activer le rapport d'analyse d'horaire`, DESCRIPTION: `` },
    ENABLESCHEDULECAPACITYDEBUGREPORT: { LABEL: `Activer le rapport de déboggage de capacité d'horaire`, DESCRIPTION: `` },
    ENABLESCHEDULEEXPORT: { LABEL: `Activer l'export d'horaire`, DESCRIPTION: `` },
    ENABLETIMEOFFREPORT: { LABEL: `Activer le rapport de congés`, DESCRIPTION: `` },
    ENABLEUNSCHEDULEDUSERSREPORT: { LABEL: `Activer le rapport d'utilisateurs non assignés à l'horaire`, DESCRIPTION: `` },
    ENABLEUSERCONTACTREPORT: { LABEL: `Activer le rapport de contacts par utilisateur`, DESCRIPTION: `` },
    ENABLEBILLINGDETAILS: {
      LABEL: `Activer les informations de facturation`,
      DESCRIPTION: `Rend disponible une section dans les quarts de travail pour y indiquer des détails de facturation.`
    },
    HIDEPROJECTCODE: {
      LABEL: `Cacher les codes de projet`,
      DESCRIPTION: `N'affichera pas le code de projet pour chaque quart de travail.`
    },
    HIDEORGANIZEBYPROJECTSCHEDULE: {
      LABEL: `Cacher la vue par projet de l'horaire`,
      DESCRIPTION: `N'affichera pas l'option d'organiser la vue de l'horaire par projet.`
    },
    HIDEORGANIZEBYPOSITIONSCHEDULE: {
      LABEL: `Cacher la vue par position de l'horaire`,
      DESCRIPTION: `N'affichera pas l'option d'organiser la vue de l'horaire par position.`
    },
    HIDEORGANIZEBYTEAMSCHEDULE: {
      LABEL: `Cacher la vue par équipe de l'horaire`,
      DESCRIPTION: `N'affichera pas l'option d'organiser la vue de l'horaire par équipe.`
    },
    HIDEORGANIZEBYUSERSCHEDULE: {
      LABEL: `Cacher la vue par employé de l'horaire`,
      DESCRIPTION: `N'affichera pas l'option d'organiser la vue de l'horaire par employé.`
    },
    HIDEORGANIZEBYUSERCHEDULE: {
      LABEL: `Cacher la vue par employé de l'horaire`,
      DESCRIPTION: `N'affichera pas l'option d'organiser la vue de l'horaire par employé.`
    }
  },
  integrationStatus: {
    LOADING_STATUS: `Chargement du statut`,
    USERS: `Utilisateurs`,
    POSITIONS: `Positions`,
    PROJECTS: `Projets`,
    SCHEDULE: `Horaire`,
    TAGS: `Étiquettes`,
    TIMEOFF: `Congés`,
    INTEGRATION_STATUS: `<0>{{type}}</0> synchronisé <1>{{lastTime}}</1>.`,
    NO_INTEGRATION_STATUS: `<0>{{type}}</0> n'a pas encore été executé.`
  },
  clientOptions: {
    SALE_IN_PROGRESS: 'Vente en cours',
    TRIAL: 'Essaie',
    ONBOARDING: 'Onbaording',
    DEMO: 'Démo',
    TEMPLATE: 'Modèle',
    ACTIVE: 'Actif',
    SLIPPING_WAY: "En train d'échapper",
    TERMINATED: 'Terminé'
  }
}
